import { render } from "./FolderElementList.vue?vue&type=template&id=14896758&scoped=true"
import script from "./FolderElementList.vue?vue&type=script&lang=js"
export * from "./FolderElementList.vue?vue&type=script&lang=js"

import "./FolderElementList.vue?vue&type=style&index=0&id=14896758&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14896758"]])

export default __exports__